export default {
  /**
   * Date range
   */
  'Month to date': '今月',
  'Year to date': '今年',
  'Last month': '先月',
  'Last 7 days': '過去7日間',
  'Last 14 days': '過去14日間',
  'Last 30 days': '過去30日間',
  'Last 90 days': '過去90日間',
  'Last 180 days': '過去180日間',
  'Last 3 months': '過去3ヶ月',
  'Last 6 months': '過去6ヶ月',
  'Last 1 year': '過去1年',

  /**
   * Granularity
   */
  Daily: '日別',
  Monthly: '月別',

  /**
   * Category / resource
   */
  productCode: 'プロダクト',
  service: 'サービス',
  account: 'アカウント',
  region: 'リージョン',
  instanceType: 'インスタンスタイプ',
  usageType: '使用タイプ',
  tags: 'タグ',
  tag: 'タグ',
  tag_resource: 'タグリソース',

  /**
   * Chart type
   */
  Stacked: '積み重ね棒チャート',
  Bar: '棒チャート',
  Line: '折れ線チャート',

  /**
   * Line stroke type
   */
  Solid: '直線',
  'Solid with bullet': '直線（ドット入り）',
  Dashed: '破線',
  'Dashed with bullet': '破線（ドット入り）',

  /**
   * Colors
   */
  red: 'レッド',
  pink: 'ピンク',
  purple: 'パープル',
  deep_purple: 'ディープパープル',
  indigo: 'インディゴ',
  blue: 'ブルー',
  light_blue: 'ライトブルー',
  cyan: 'シアン',
  teal: 'ティール',
  green: 'グリーン',
  light_green: 'ライトグリーン',
  lime: 'ライム',
  yellow: 'イエロー',
  amber: 'アンバー',
  orange: 'オレンジ',
  deep_orange: 'ディープオレンジ',
  brown: 'ブラウン',
  grey: 'グレイ',
  blue_grey: 'ブルーグレイ',

  /**
   * File type
   */
  CSV: 'CSV',
  XLSX: 'XLSX',
  JSON: 'JSON',
  HTML: 'HTML',
  PNG: 'PNG',
  JPG: 'JPG',
  SVG: 'SVG',
  PDF: 'PDF',
};
